import { createAction, props } from '@ngrx/store'
import { createAsyncConstants } from '../../shared/utils'
import { Coordinates } from '../location/location.types'
import { Appointment, AppointmentDate, AppointmentRequest } from './appointment.types'

export const APPOINTMENT_DATE = createAsyncConstants('APPOINTMENT_DATE')
export const APPOINTMENT_SELECTED = 'APPOINTMENT_SELECTED'
export const APPOINTMENT_SELECTED_RESET = 'APPOINTMENT_SELECTED_RESET'
export const APPOINTMENT_DIALOG = 'APPOINTMENT_DIALOG'
export const APPOINTMENT_AVAILABILITY = 'APPOINTMENT_AVAILABILITY'
export const APPOINTMENT_AVAILABILITY_REQUESTS_COMPLETED = 'APPOINTMENT_AVAILABILITY_REQUESTS_COMPLETED'
export const APPOINTMENT_AVAILABILITY_RESET = 'APPOINTMENT_AVAILABILITY_RESET'

export const requestAppointmentDate = createAction(
  APPOINTMENT_DATE.REQUEST,
  props<{ payload: AppointmentRequest }>()
)

export const appointmentDateSuccess = createAction(
  APPOINTMENT_DATE.SUCCESS,
  props<{ payload: AppointmentDate }>()
)

export const appointmentDateFailure = createAction(
  APPOINTMENT_DATE.FAILURE,
  props<{ payload: Date }>()
)

export const requestAppointmentAvailability = createAction(
  APPOINTMENT_AVAILABILITY,
  props<{ payload: Coordinates }>()
)

export const appointmentDateRequestsCompleted = createAction(APPOINTMENT_AVAILABILITY_REQUESTS_COMPLETED)

export const selectAppointment = createAction(
  APPOINTMENT_SELECTED,
  props<{ payload: Appointment }>()
)

export const resetSelectedAppointment = createAction(APPOINTMENT_SELECTED_RESET)

export const resetAppointmentAvailability = createAction(APPOINTMENT_AVAILABILITY_RESET)

export const toggleAppointmentDialog = createAction(
  APPOINTMENT_DIALOG,
  props<{ payload: boolean }>()
)
